module.exports = __webpack_public_path__ + "img/Right-top.60f85686.svg";